module.exports = __webpack_public_path__ + "media/images/icons/telegram-4bcc26c0602dc9b0238120d34f208343.svg";